import axios, {AxiosResponse} from 'axios'
import {useIntl} from 'react-intl'
import React, {useEffect, useState } from 'react';
import {UserModel} from '../../auth/models/UserModel'
import {RootState} from '../../../../setup'
import {shallowEqual, useSelector} from 'react-redux'
import {CVModel} from '../models/CVModel'
import {KTSVG} from '../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import GetTaxoTerms from '../../builderform/GetTaxoTerms'
import {Collapse, Button} from 'react-bootstrap-v5'
import CVList from './CVList'

import {PagerList} from '../../widgets/components/PagerList' 

const API_URL = process.env.REACT_APP_API_URL
const LIST_URL = `${API_URL}/list/cv?`
const headers = {
    "Content-Type" : "application/hal+json",
    "Accept" : "application/hal+json"
}

export type TPublicationList = CVModel[]

export function CV(){
    const intl = useIntl()
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const userId = user.role === 'administrator' ? '': user.id
    const initFilters = [
        {name : 'user', value: userId},
        {name : 'keyword', value: ''},
        {name : 'status', value: ''},
        {name : 'faculty', value: ''},
        {name : 'campus', value: ''},
    ]

    const [publications, setPublicationList] = useState<CVModel[]>([]);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState(initFilters)
    const [openFilters, setOpenFilters] = useState(false)
    const [total, setTotal] = useState(0)
    
    
    const [pager, setPager] = useState<any>([]);
    const [currentPage, setCurrentPage] = useState<any>(0);

    function fetchPublications(page: any) {
	    setLoading(true);
        let buildGet = ''
        Object.entries(filters).forEach((fil : any)=>{
            if(fil[1].value !== ''){
                buildGet += fil[1].name+'='+fil[1].value+'&'
            }
        })
        const full_url = LIST_URL + encodeURI(buildGet) + "page=" + page
       // console.log(full_url)
        axios.get(full_url, {headers})
            .then((response: AxiosResponse) => {
	            window.scrollTo({
			      top: 0,
			      left: 0,
			      behavior: 'smooth'
			    });
                setPublicationList( response.data.results );
               // console.log(response.data.results)
                setPager( response.data.pager );
                setTotal(response.data.pager.count)
                setLoading(false);
            });
    }

    const FilteringPublications = (e : any) => {
        setLoading(true);
        const objIndex = filters.findIndex((obj => obj.name === e.target.name));
        filters[objIndex].value = e.target.value
        fetchPublications(0);
    };

    useEffect(()=>{
        fetchPublications(0)
    }, [])

    var nbR;
    if (total === 0) {
        nbR = intl.formatMessage({id: 'EDHEC.LABEL.NO_RESULT'});
    }
    else if(total === 1){
        nbR = total +' '+ intl.formatMessage({id: 'EDHEC.LABEL.RESULT'});
    }
    else{
        nbR = total +' '+ intl.formatMessage({id: 'EDHEC.LABEL.RESULTS'});
    }
    return(
        <div>
            {user.role === 'administrator'&&
            <Link to='/profile/add' className='btn btn-sm btn-secondary me-3 mb-5'>
                <KTSVG
                    path='/media/icons/duotune/arrows/arr075.svg'
                    className='svg-icon-1 svg-icon-primary'
                />
                {intl.formatMessage({id: 'EDHEC.LABEL.ADD_CV'})}
            </Link>
            }
            <div className={`card`}>
                <div className='card-header border-0 pt-5'>
                    <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bolder fs-3 mb-1'>{user.role === 'administrator' ? intl.formatMessage({id: 'EDHEC.ALL_CV'}): intl.formatMessage({id: 'EDHEC.LABEL.CV'})}</span>
                        <span className='text-muted mt-1 fw-bold fs-7'>{nbR}</span>
                    </h3>
                    <div className='card-toolbar'>
                        <Button className="me-3" onClick={()=> setOpenFilters(!openFilters)} aria-expanded={openFilters} aria-controls="filtersCollapse">
                            <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-3' />
                            {intl.formatMessage({id: 'EDHEC.LABEL.FILTERS'})}
                        </Button>
                        <form className='form'>
                            <label className='form-check form-check-custom form-check-solid align-items-start'>
                                <input
                                    name='keyword'
                                    type='text'
                                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                    placeholder={intl.formatMessage({id: 'EDHEC.LABEL.KEYWORD'})+'...'}
                                    onChange={FilteringPublications}
                                />
                            </label>
                        </form>
                    </div>
                </div>
                <Collapse in={openFilters}>
                    <div id='filtersCollapse'>
                        <div className='card-body pt-5'>
                            <form className='border form py-2 d-flex row justify-content-between'>
                                <div className='d-flex column py-2'>
                                    <div className='px-2'>
                                        <select
                                            name='status'
                                            className='px-2 form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                            onChange={FilteringPublications}
                                        >
                                            <GetTaxoTerms name='statut' title='status'/>
                                        </select>
                                    </div>
                                    <div className='px-2'>
                                        <select
                                            name='faculty'
                                            className='px-2 form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                            onChange={FilteringPublications}
                                        >
                                            <GetTaxoTerms name='faculty' title='faculty'/>
                                        </select>
                                    </div>
                                    <div className='px-2'>
                                        <select
                                            name='campus'
                                            className='px-2 form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                            onChange={FilteringPublications}
                                        >
                                            <GetTaxoTerms name='campus' title='campus'/>
                                        </select>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Collapse>
                <div className='card-body py-3'>
                    <div className='table-responsive'>
                        <table className='table align-middle gs-0 gy-4'>
                            <thead>
                            <tr className='fw-bolder text-muted bg-light'>
                                <th className='ps-4 rounded-start'>{intl.formatMessage({id: 'EDHEC.LABEL.NAME'})}</th>
                                <th>{intl.formatMessage({id: 'EDHEC.LABEL.JOB'})}</th>
                                <th>{intl.formatMessage({id: 'EDHEC.LABEL.FACULTY'})}</th>
                                <th>{intl.formatMessage({id: 'EDHEC.LABEL.CAMPUS'})}</th>
                                <th>{intl.formatMessage({id: 'EDHEC.LABEL.UPDATE'})}</th>
                                <th>{intl.formatMessage({id: 'EDHEC.LABEL.STATUS'})}</th>
                                <th className='text-end rounded-end'></th>
                            </tr>
                            </thead>
                            <tbody>
                            { loading ?(
                                <tr><td>
                                    <div className='d-flex align-items-center justify-content-center m-5'>
                                        loading...
                                    </div>
                                </td></tr>
                            ):(
                                <CVList items={publications}/>
                            )}
                            </tbody>
                        </table>
                        
                        <>
                        	<PagerList pager={pager} current_page={currentPage} setPage={setCurrentPage} reloadList={fetchPublications}/>
                        </>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function generatePDF(id: number, title: string, setLoader: any, index: any){
    setLoader({state: true, index: index})
    axios({
        method: 'get',
        url: `${API_URL}/services/cv/generate?id=`+ id,
        headers: headers,
        responseType: 'blob'
    })
    .then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data],{type: 'application/pdf'}));
        const link = document.createElement('a');
        link.href = url;
        setLoader({state: false, index: index})
        window.open(url, '_blank');
        //link.setAttribute('download', title+'.pdf'); //or any other extension
        //link.setAttribute('target', '_blank'); //or any other extension
        document.body.appendChild(link);
        //link.click();
    });
}

export function NbMembers(){

    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const userId = user.role === 'administrator' ? '': user.id
    const [nbTeam, setNbTeam] = useState(0)
    const full_url = LIST_URL +'user='+ userId
    axios.get(full_url, {headers})
        .then((response: AxiosResponse) => {
            setNbTeam( response.data.results.length );
        });
    return (
        <span className='text-muted fs-5'> ({nbTeam})</span>
    )
}
